import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import {
  AgrPageToolbarModule,
  AgrPrimaryActionModule,
  AgrPageDetailModule,
  AgrNotificationEmptyModule,
  AgrBlockSpinnerModule,
} from '@next/core-lib/components';
import { AgrFormModule } from '@next/core-lib/form';
import { TableV2Module } from '@next/core-lib/table-v2';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';

import { CustomerDetailComponent } from './components/customer-detail/customer-detail.component';
import { CustomerItemComponent } from './components/customer-item/customer-item.component';
import { CustomerNavigationComponent } from './components/customer-navigation/customer-navigation.component';
import { CustomerOverviewComponent } from './components/customer-overview/customer-overview.component';
import { CustomerLocationDetailComponent } from './components/locations/customer-location-detail/customer-location-detail.component';
import { CustomerLocationsComponent } from './components/locations/customer-locations/customer-locations.component';
import { CustomerComponent } from './customer.component';
import { CustomerService } from './services/customer.service';
import { CustomerEffects } from './store/customer.effects';
import * as customerReducer from './store/customer.reducer';
import { AgrSearchFieldModule } from '../shared/components/search-field/search-field.module';

@NgModule({
  declarations: [
    CustomerComponent,
    CustomerOverviewComponent,
    CustomerItemComponent,
    CustomerDetailComponent,
    CustomerLocationsComponent,
    CustomerNavigationComponent,
    CustomerLocationDetailComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    AgrSearchFieldModule,
    AgrPageToolbarModule,
    AgrPageDetailModule,
    AgrPrimaryActionModule,
    AgrNotificationEmptyModule,
    AgrBlockSpinnerModule,
    MatListModule,
    MatDividerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    ReactiveFormsModule,
    AgrFormModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatTabsModule,
    MatSlideToggleModule,
    TableV2Module,
  ],
  providers: [
    CustomerService,
    provideState('customerModule', customerReducer.reducer),
    provideEffects([CustomerEffects]),
  ],
})
export class CustomerModule {}
